import axios from 'axios'
import router from '../router/index'
import {useCookies} from "vue3-cookies";
import {UserApi} from "@/api/user";
import moment from "moment/moment";

const {cookies} = useCookies();

const DOMAINS = [

    {
        domain: 'localhost',
        logo: 'orion',
        favicon: 'orion.svg',
        name: "Форпост",
        styles: ['orion'],
        pwa: {
            icons: "orion_icons"
        }
    }]
const User = {
    state: {
        user: {},
        tariff: {},
        route: null,
        is_auth: localStorage.getItem('is_auth') || false,
        remember: localStorage.getItem('remember') || false,
        sidebar_state: !localStorage.getItem("hide_sidebar"),
        jwt: cookies.get("token") || null,
        currentProjectId: localStorage.getItem("currentProjectId") || null,
        filterDateFrom: localStorage.getItem("filterDateFrom") || moment().subtract(1, 'month').format("YYYY-MM-DD"),
        filterDateTo: localStorage.getItem("filterDateTo") || moment().format("YYYY-MM-DD"),
        currentProject: {},
        load: false
    },
    mutations: {
        set_project(state, project) {
            state.currentProject = project
        },
        set_route(state, route) {
            state.route = route
        },
        set_project_id(state, project_id) {
            state.currentProjectId = project_id;
            localStorage.setItem("currentProjectId", project_id);
        },
        toggle_sidebar(state) {
            state.sidebar_state = !state.sidebar_state;
            if (state.sidebar_state) localStorage.removeItem("hide_sidebar");
            else localStorage.setItem("hide_sidebar", "true");
        },
        set_filter_dates(state, dates) {
            if (dates.from) {
                localStorage.setItem("filterDateFrom", dates.from);
                state.filterDateFrom = dates.from
            }
            if (dates.to) {
                localStorage.setItem("filterDateTo", dates.to);
                state.filterDateTo = dates.to
            }
        },
        auth_success(state, user) {
            state.user = user;
            state.is_auth = true;
            localStorage.setItem("is_auth", true);
            localStorage.setItem("user_type", user.user_type);
            if (state.remember) {
                localStorage.setItem("username", user.username);
                state.username = user.username;
            } else {
                localStorage.removeItem("username");
                state.username = null;
            }
            this.dispatch('get_tariff');

        },
        set_tariff(state, tariff) {
            state.tariff = tariff;
        },
        updateToken(state, newToken) {
            cookies.set("token", newToken, '30D', "/");
            state.jwt = newToken;
        },
        logout(state) {
            state.user = {};
            localStorage.removeItem("is_auth");
            localStorage.removeItem("token");
            cookies.remove("token", "/");
            state.currentProjectId = null;
            localStorage.removeItem("currentProjectId");
            state.is_auth = false;
            state.jwt = null;
        },
        setRemember(state, remember) {
            if (remember) localStorage.setItem("remember", remember);
            else localStorage.removeItem("remember");
            state.remember = remember;
        },

        loader(state, status) {
            state.load = status;
        },
    },
    actions: {
        init({dispatch}, need_permission) {

            if (this.getters.jwt) {
                return Promise.all([
                    dispatch('refresh_token'),
                    // dispatch('get_user')
                ])
            }
        },
        toggle_sidebar({commit}) {
            commit("toggle_sidebar")
        },
        setFilterDates({commit}, dates) {
            commit("set_filter_dates", dates)
        },
        setProjectId({commit}, project_id) {
            commit("set_project_id", project_id)
        },
        login({commit, dispatch}, user) {
            return new Promise((resolve, reject) => {
                axios.post('/auth/obtain_token/', user).then((response) => {
                    commit("updateToken", response.data.token);
                    dispatch('get_user');
                    setTimeout(function () {
                        if (router.currentRoute.value.query.next){
                            location.pathname = router.currentRoute.value.query.next
                        }
                        else location.reload();
                    }, 300);

                    resolve(response);
                })
                    .catch((error) => {
                        console.log(error);
                        reject(error)
                    });
            })
        },

        refresh_token({commit, dispatch}) {
            let $this = this;
            if ($this.getters.jwt) return new Promise((resolve, reject) => {
                axios.post('/auth/refresh_jwt_token/', {token: $this.getters.jwt}).then((response) => {
                    commit("updateToken", response.data.token);
                    dispatch('get_user');
                    resolve(response);
                }).catch((error) => {
                    commit('logout');
                    reject(error)
                })
            })
        },
        get_user({commit, getters}) {
            let $this = this;
            return new Promise((resolve) => {
                const base = {
                    baseURL: getters.api_path,
                    headers: {
                        Authorization: `JWT ${$this.getters.jwt}`,
                        "Content-Type": "application/json",
                    },
                    xhrFields: {
                        withCredentials: true,
                    },
                };
                const axiosInstance = axios.create(base);
                axiosInstance({
                    url: "/users/get_info/",
                    method: "get",
                    params: {},
                }).then((response) => {
                    response.data.path = '/';
                    commit('auth_success', response.data);

                    resolve(response);
                });
            })
        },
        update_user({dispatch}, user) {
            UserApi.update_user(user).then(() => dispatch('get_user'));

        },
        get_tariff({commit, getters}) {
            let $this = this;
            return new Promise((resolve,) => {
                const base = {
                    baseURL: getters.api_path,
                    headers: {
                        Authorization: `JWT ${$this.getters.jwt}`,
                        "Content-Type": "application/json",
                    },
                    xhrFields: {
                        withCredentials: true,
                    },
                };
                const axiosInstance = axios.create(base);
                axiosInstance({
                    url: "/users/get_tariff/",
                    method: "get",
                    params: {},
                }).then((response) => {
                    if (response.data.name) {
                        commit('set_tariff', response.data);
                        // const $route = router.currentRoute.value;
                        // console.log($route)
                        // if ($route.query.next||$route.query.name === "project_change"){
                        //
                        //     if ($route.query.next) router.push($route.query.next);
                        // }
                        // else if (!getters.currentProjectId) router.push('/project/');
                    } else {
                        if (router.currentRoute.value.path !== '/tariff/') router.push('/tariff/');
                    }

                    resolve(response);
                });
            })
        },
        logout({commit}) {
            return new Promise((resolve) => {
                axios.get('/auth/logout/')
                    .then(() => {
                        commit('logout');
                        localStorage.removeItem("selected_resources_rating");
                        localStorage.removeItem("selected_resources_review_count");
                        localStorage.removeItem("selected_resources_day");
                        localStorage.removeItem("filterDateTo");
                        localStorage.removeItem("dateFrom");
                        router.push('/login/');
                        resolve()
                    })

            })
        },
        go_404() {
            router.push({name: '404'});
        },
        go_403() {
            router.push({name: '403'});
        },

        loader({commit}, status) {
            commit('loader', status)
        }
    },
    getters: {
        isLoggedIn: state => state.is_auth,
        getRoute: (state) => state.route,
        user: state => state.user,
        currentProject: state => state.currentProject,
        tariff: state => state.tariff,
        jwt: state => state.jwt,
        api_path: () => process.env.VUE_APP_DEV_MODE ? process.env.VUE_APP_ROOT_API : `${location.protocol}//${location.host}/api/v1/`,
        company: () => DOMAINS.filter(x => location.host.includes(x.domain))?.[0] || DOMAINS[0],
        sidebar_state: (state) => state.sidebar_state,
        currentProjectId: (state) => state.currentProjectId,
        load: state => state.load,
        filterDateFrom: state => state.filterDateFrom,
        filterDateTo: state => state.filterDateTo,

    }
};

export default User;
